/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm, reset } from 'redux-form'
import { withLocalization } from 'hocs/localization'
import { changeEmail } from 'api/client/actions/userSettings'
import { onShowError } from 'redux-app/modules/alerts'
import { openModal, closeModal } from 'redux-app/modules/modals'
import { isUserUnableToUpdateInfo } from 'redux-app/selectors/user'
import { SUCCESS_MODAL } from './contants'
import ChangeEmailForm from './ChangeEmailForm'

const FORM_NAME = 'changeEmail'

export default compose(
  withLocalization('profile.settings.changeEmail'),
  connect(
    state => ({
      isUserUnableToUpdateInfo: isUserUnableToUpdateInfo(state),
    }),
    {
      changeEmail,
      onShowError,
      reset,
      openModal,
      closeModal,
    },
  ),
  withHandlers({
    onSubmit: ({ changeEmail, onShowError, openModal, reset }) => formValues => {
      return changeEmail(formValues)
        .then(() => {
          openModal({ name: SUCCESS_MODAL })
          reset(FORM_NAME)
        })
        .catch(error => {
          onShowError(error)
        })
    },
    onFinish: ({ closeModal }) => () => {
      closeModal({ name: SUCCESS_MODAL })
    },
  }),
  reduxForm({
    form: FORM_NAME,
  }),
)(ChangeEmailForm)
